import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import emissaoBoleto from '@/views/boletos/EmissaoBoletos.vue'
import BoletosGerenciar from '@/views/boletos/BoletosGerenciar.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'boleto-emitir',
      name: 'boleto-emitir',
      component: emissaoBoleto,
      meta: {
        requiresAuth: true,
        title: 'Emissão de Boletos',
        nome_fisico: 'boleto-emitir',
      },
    },
    {
      path: 'boleto-gerenciar',
      name: 'boleto-gerenciar',
      component: BoletosGerenciar,
      meta: {
        requiresAuth: true,
        title: 'Gerenciar Boletos',
        nome_fisico: 'boleto-gerenciar',
      },
    },
  ],
}
